import React from 'react'
import PropTypes from 'prop-types'
import styles from './Center.scss'

export default function Center({ children }) {
  return <div className={styles.Center}>{children}</div>
}

Center.propTypes = {
  children: PropTypes.any,
}



// WEBPACK FOOTER //
// ./src/components/Center/index.js